const TagQueryKeys = {
  global: ["tags"] as const,
  trending: () => [...TagQueryKeys.global, "trending"] as const,
};

export { TagQueryKeys };
